import moment from 'moment';

export const DEFAULT_DASHBOARD_RANGE = Object.freeze({
  mode: 'default',
  from: null,
  to: null,
  preset: 'default',
});

export const DASHBOARD_DEFAULT_WINDOWS = Object.freeze({
  trendDays: 14,
  heatmapDays: 7,
});

export function createDefaultDashboardRange() {
  // Return the shared frozen default instead of a fresh copy. Callers can
  // invoke this on every render/handler, and a new object per call used to
  // churn the dateRange state (and every effect keyed on it) without any
  // real change. The object is frozen, so returning it directly is safe.
  return DEFAULT_DASHBOARD_RANGE;
}

export function isCustomDashboardRange(range) {
  return range?.mode === 'custom'
    && Number.isFinite(range.from)
    && Number.isFinite(range.to);
}

export function isValidDashboardRange(range) {
  return isCustomDashboardRange(range) && range.from <= range.to;
}

export function createPresetDashboardRange(preset, now = Date.now()) {
  if (preset === 'default') return createDefaultDashboardRange();

  const current = moment(now);
  let from;
  if (preset === 'today') {
    from = current.clone().startOf('day');
  } else if (preset === 'last-7-days') {
    from = current.clone().subtract(6, 'days').startOf('day');
  } else if (preset === 'last-30-days') {
    from = current.clone().subtract(29, 'days').startOf('day');
  } else if (preset === 'this-month') {
    from = current.clone().startOf('month');
  } else {
    return createDefaultDashboardRange();
  }

  return {
    mode: 'custom',
    from: from.valueOf(),
    to: current.clone().endOf('day').valueOf(),
    preset,
  };
}

